
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MapPin, Clock, Briefcase } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import InquiryForm from "@/components/services/InquiryForm";

const Careers = () => {
  const jobs = [
    {
      title: "Senior Software Engineer",
      location: "Remote",
      type: "Full-time",
      experience: "5+ years",
      description: "We're looking for a Senior Software Engineer to join our team and help build innovative solutions.",
      requirements: [
        "Experience with React and TypeScript",
        "Strong problem-solving skills",
        "Experience with cloud platforms",
      ]
    },
    {
      title: "Product Manager",
      location: "New York, NY",
      type: "Full-time",
      experience: "3+ years",
      description: "Join us as a Product Manager to help shape the future of our solutions.",
      requirements: [
        "Experience in software product management",
        "Strong analytical skills",
        "Excellent communication abilities",
      ]
    },
    {
      title: "UX/UI Designer",
      location: "Remote",
      type: "Full-time",
      experience: "2+ years",
      description: "We're seeking a talented UX/UI Designer to create exceptional user experiences.",
      requirements: [
        "Portfolio of design work",
        "Experience with Figma",
        "Understanding of user-centered design",
      ]
    }
  ];

  return (
    <div className="min-h-screen py-12 bg-gradient-to-b from-indigo-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-800 dark:text-white text-center mb-6">Join Our Team</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 text-center max-w-3xl mx-auto mb-12">
          Join our team of passionate professionals and help shape the future of business solutions.
        </p>

        <div className="grid grid-cols-1 gap-8 max-w-4xl mx-auto">
          {jobs.map((job, index) => (
            <Card key={index} className="curved-xl shadow-soft hover:shadow-lg transition-shadow border border-gray-100 dark:border-gray-700">
              <CardHeader>
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <CardTitle className="text-xl mb-2 text-gray-800 dark:text-white">{job.title}</CardTitle>
                    <div className="flex flex-wrap gap-4 text-sm text-gray-600 dark:text-gray-300 mt-2">
                      <div className="flex items-center">
                        <MapPin className="h-4 w-4 mr-1 text-indigo-600 dark:text-indigo-400" />
                        {job.location}
                      </div>
                      <div className="flex items-center">
                        <Clock className="h-4 w-4 mr-1 text-indigo-600 dark:text-indigo-400" />
                        {job.type}
                      </div>
                      <div className="flex items-center">
                        <Briefcase className="h-4 w-4 mr-1 text-indigo-600 dark:text-indigo-400" />
                        {job.experience}
                      </div>
                    </div>
                  </div>
                  <Badge variant="secondary" className="rounded-full bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200">{job.type}</Badge>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 dark:text-gray-300 mb-4">{job.description}</p>
                <div className="mb-4">
                  <h3 className="font-semibold mb-2 text-gray-800 dark:text-white">Requirements:</h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-300">
                    {job.requirements.map((req, idx) => (
                      <li key={idx}>{req}</li>
                    ))}
                  </ul>
                </div>
                <Sheet>
                  <SheetTrigger asChild>
                    <Button className="w-full curved-xl btn-gradient text-white">Apply Now</Button>
                  </SheetTrigger>
                  <SheetContent side="right" className="w-[90vw] sm:w-[540px] overflow-y-auto curved-xl">
                    <SheetHeader>
                      <SheetTitle>Apply for {job.title}</SheetTitle>
                      <SheetDescription>
                        Please fill out the application form below for the {job.title} position.
                      </SheetDescription>
                    </SheetHeader>
                    <InquiryForm service={job.title} formType="job" />
                  </SheetContent>
                </Sheet>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Careers;
